import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMasterDataKeyList, createMasterDataKey, fetchMasterKeyByApiKey, downloadBulkMasterKeyRequestTemplate, submitBulkMasterKeyRequest } from '../action';
import withAuth from '../../../components/Services/WithAuth';
import './style.scss';
import { Col, Card, CardBody, Row, Button, Label, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import Modal from '../../../components/UI/Modal/Modal';
import CreateMasterData from './CreateMasterData/index';
import MasterDataFilter from './MasterDataFilter/index';
import TableView from './TableView/index';
import { DEFAULT_REQUEST_BODY, DEFAULT_PAGE_SIZE, DEFAULT_PAGE_NUMBER, DEFAULT_SORTING } from './constants';
import { toast } from 'react-toastify';
import { setAppliedfilters, removeFilterValue, removeAppliedFilterData, clearAllFilter, setRequestBody } from './helper';
import { Preloading } from '../../../components/UI/Preloader/action';
import fileSaver from 'file-saver';

class MasterDataCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            showModal: false,
            body: null,
            loading: true,
            columns: [],
            appliedFiltersList: [],
            appliedFilter: [],
            warnModal: false,
            bulkMasterkeyRequestExcel: '',
            noExcelUploadWarning: '',
            resizeZIndex: false,
            showFailureModal: false,
            failureMessageHeading: '',
            failureMessageBody: ''
        }
    }
    componentDidMount() {
        this.props.getMasterDataKeyList(DEFAULT_REQUEST_BODY);

    }
    componentDidUpdate(prevProps) {
        const { listData, createMasterDataSuccess, createMasterDataFailure, masterkeysByApiKeySuccess, masterkeysByApiKeyFailure, downloadBulkMasterKeyRequestTemplateSuccess, downloadBulkMasterKeyRequestTemplateFailure, submitBulkMasterKeyRequestSuccess, submitBulkMasterKeyRequestFailure } = this.props
        if (listData !== prevProps.listData) {
            this.setState({
                loading: false
            })
        }
        if (createMasterDataSuccess !== prevProps.createMasterDataSuccess) {
            toast.success(
                <div>
                    {createMasterDataSuccess.name} Created Successfully
                </div>
            );
            this.handleToggle();
            this.props.getMasterDataKeyList();
        }
        if (createMasterDataFailure !== prevProps.createMasterDataFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{createMasterDataFailure.data.message}
                </div>
            );
        }
        if (masterkeysByApiKeySuccess !== prevProps.masterkeysByApiKeySuccess) {
            if(this.props.masterkeysByApiKeySuccess.length > 0){
                this.handleWarningToggle();
            }
            this.props.preloading(false);
            this.setState((prevState) => ({
                showModal: !prevState.showModal}))
        }
        if (masterkeysByApiKeyFailure !== prevProps.masterkeysByApiKeyFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{masterkeysByApiKeyFailure.data.message}
                </div>
            );
        }

        if (downloadBulkMasterKeyRequestTemplateSuccess !== prevProps.downloadBulkMasterKeyRequestTemplateSuccess) {
            this.props.preloading(false)
            var blob = new Blob([downloadBulkMasterKeyRequestTemplateSuccess], { type: 'application/octet-stream' });
            fileSaver.saveAs(blob, `Bulk_master_key_request_template.xlsx`);
        }
        if (downloadBulkMasterKeyRequestTemplateFailure !== prevProps.downloadBulkMasterKeyRequestTemplateFailure) {
            this.props.preloading(false)
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br/>&nbsp;Please try again!
                </div>
            );
        }

        if (submitBulkMasterKeyRequestSuccess !== prevProps.submitBulkMasterKeyRequestSuccess) {
            this.props.preloading(false)

            if(submitBulkMasterKeyRequestSuccess.validationFailureReason) { //on validation failure
                let errorMessage = ''
                if(submitBulkMasterKeyRequestSuccess.errorCellsOfColumn.length > 0 ) { 
                    submitBulkMasterKeyRequestSuccess.errorCellsOfColumn.forEach(errorCell => {
                        let totalRows = errorCell.rows.length
                        if(totalRows > 0) {
                            let tempErrorMessage = `${errorCell.column} rows: `
                            tempErrorMessage += errorCell.rows[0]       //adding first element
                            let maxElemInALine = 10                  //excluding the first element

                            //starting from second element because first is already added in string
                            //formatting element line by line
                            for(let i = 1; i< totalRows; i+=maxElemInALine) {    //loop for each line
                                let elemUpperLimit = totalRows - i;             //calculating upper limit so element index cannot get outside
                                let noOfElemForLine = elemUpperLimit < maxElemInALine ? elemUpperLimit : maxElemInALine;        //calculating number of row elements for the current line
                                
                                for(let j=0; j < noOfElemForLine; j++)              // loop for formatting each element inside line
                                    tempErrorMessage += `, ${errorCell.rows[(i+j)]}`;
                                
                                tempErrorMessage += `\n`            //changing line after filling row elements
                            }
                            tempErrorMessage += `\n`
                            errorMessage += tempErrorMessage;
                        }
                    });
                }
                this.setState({
                    showFailureModal: true,
                    failureMessageHeading: submitBulkMasterKeyRequestSuccess.validationFailureReason,
                    failureMessageBody: errorMessage
                })
            }

            else{                               //on validation success
                this.setState({
                    noExcelUploadWarning: '',
                    bulkMasterkeyRequestExcel: ''
                })
            
                toast.success(
                    <div>
                        <i className="fa fa-check-circle fa-lg"></i>&nbsp;Submitted Succesfully!
                    </div>
                );
            }
        }


        if (submitBulkMasterKeyRequestFailure !== prevProps.submitBulkMasterKeyRequestFailure) {
            this.props.preloading(false)
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Something went wrong!<br/>&nbsp;Please try again!
                </div>
            );
            
        }
    }

    handleToggle = () => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
            body: null
        }))
    }
    handleWarningToggle = () => {
        this.setState((prevState) => ({
            warnModal: !prevState.warnModal
        }))
    }
    getMasterkeys = (data) => {
            this.setState((prevState) => ({
                showModal: !prevState.showModal}))
            this.props.preloading(true);
            this.props.fetchMasterKeyByApiKey(data);
    }
    handleCreateMasterKey = () => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
            body: <CreateMasterData initialValues={{ name: '1', apiKey: '2', dataType: '3', keyType: '4' }} closeModal={this.handleToggle} createCallback={this.handleCreate} handleGetMasterKeys={this.getMasterkeys} />
        }))
    }
    handleCreate = (data) => {
        this.props.createMasterDataKey(data)
    }
    handleAppliedFilters = (filterData) => {
        const tempFilterData = setAppliedfilters(filterData)
        this.setState({
            appliedFilter: filterData,
            appliedFiltersList: tempFilterData
        }, () => {
            this.onFetchPage(DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, DEFAULT_SORTING)
        })
    }
    handleRemoveFilter = (filterData, index) => {
        const tempRemoveFilter = removeFilterValue(index, this.state.appliedFiltersList);
        const tempAppliedFilter = removeAppliedFilterData(filterData, this.state.appliedFilter)
        this.setState({
            appliedFilter: tempAppliedFilter,
            appliedFiltersList: tempRemoveFilter
        }, () => {
            this.onFetchPage(DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, DEFAULT_SORTING)
        });

    }
    handleClearAll = () => {
        this.setState((prevState) => ({
            appliedFiltersList: [],
            appliedFilter: clearAllFilter(prevState.appliedFilter)
        }), () => {
            this.onFetchPage(DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, DEFAULT_SORTING)
        })
    }
    onFetchPage = (pageNo, pageSize, sorted) => {
        const requestBody = setRequestBody(pageNo, pageSize, sorted, this.state.appliedFiltersList, this.state.searchText)
        this.props.getMasterDataKeyList(requestBody);
    }
    handleSearchText = (searchText) => {
        this.setState({
            searchText: searchText
        }, () => {
            this.onFetchPage(DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, DEFAULT_SORTING)
        })
    }

    uploadExcel = (event) => {
        this.setState({
            bulkMasterkeyRequestExcel: event.target.files[0]
        })    
        
        event.preventDefault();
        event.target.value = null;
    }

    handleSubmit = () => {
        if(!this.state.bulkMasterkeyRequestExcel) {
            this.setState({ noExcelUploadWarning: '*Please upload the filled request template!'})
        }
        else{
        this.props.submitBulkMasterKeyRequest({file: this.state.bulkMasterkeyRequestExcel});
        this.props.preloading(true);
        }
    }

    handleCloseModal = () => {
        this.setState({
            showFailureModal:false
        })
    }

    handleTemplateDownload = () => {
        this.props.preloading(true)
        this.props.downloadBulkMasterKeyRequestTemplate({caseType: this.state.caseType})
    }

    render() {
        const { listData } = this.props;
        return (
            <Col>
                <Row>
                    <Col sm='22'>
                        <h4>View All Master Data Keys</h4>
                    </Col>
                </Row>
                <Row>
                    <Col sm='22'>
                        <MasterDataFilter searchCallback={this.handleSearchText} appliedFilterValues={this.state.appliedFilter} masterDataFiltercallback={this.handleAppliedFilters} />
                    </Col>
                    <Col sm='2'>
                        <Button className='btn create-button' color='primary' onClick={this.handleCreateMasterKey}>Add</Button>
                    </Col>
                </Row>
                <Row>
                    <Col sm='22'>
                        
                        <Button color="primary" onClick={this.handleTemplateDownload} className="btn color-excel-download ">
                                                    <i className="fa fa-file-excel-o fa-lg"></i>&nbsp;&nbsp;Download Request Template
                        </Button> 
                        <Row color="primary" className="btn btn-primary ml-0 position-relative excel-upload-btn browse-files ml-3" title="Upload Request Template">
                            <input onChange={this.uploadExcel} type="file" name="file" id="file" className="upload-file" title="Upload Request Template" />
                            <i className="fa fa-paperclip color-888 rotate-90deg p-1 fa-lg" /> Browse File(s)
                            
                        </Row>
                        <Button className='ml-5' color='primary' onClick={this.handleSubmit}>Submit</Button>
                        <Row className={(this.state.bulkMasterkeyRequestExcel) ? "text-muted ml-1 transaction-file-name-text" : "text-danger ml-1 noUploadWarning-text" }>{(this.state.bulkMasterkeyRequestExcel) ? this.state.bulkMasterkeyRequestExcel.name : this.state.noExcelUploadWarning}</Row>
                    </Col>
                </Row>
                <div className="no-gutters mb-3 d-flex flex-column flex-sm-row">
                    <Label className="filter-title col-sm-3 pr-0">Applied Filters :</Label>
                    <div className="col-sm-21 pl-0 filter d-flex flex-wrap align-items-center">
                        {this.state.appliedFiltersList.map((p, index) => {
                            return (
                                <span key={p.label} className="filter-item d-flex align-items-center mr-2 mb-2">
                                    {p.label} <i className="icon-close pointer" onClick={() => this.handleRemoveFilter(p, index)}></i>
                                </span>
                            )
                        })}
                        {(this.state.appliedFiltersList.length > 0) ? <Button className="filter-item filter-item-btn-clear" color="primary" size="xs" onClick={this.handleClearAll}>Clear All</Button> : null}
                    </div>
                </div>
                <Row>
                    <Card className='master-data-table'>
                        <CardBody>
                            {/* <Table
                                data={this.props.listData.masterDataKeyList}
                                columns={TABLE_COLUMNS}
                                minRows={3}
                                defaultPageSize={10}
                                loading={this.state.loading}
                                noDataText="No Section Template Found"
                                onFetchPage={this.onFetchPage} />
                                */}
                            <TableView tasks={this.props.listData} onFetchPage={this.onFetchPage} />
                        </CardBody>
                    </Card>
                </Row>
                <Modal show={this.state.showModal} className={this.state.warnModal ? "z-index-zero Modal" : "Modal"} >
                    {/* <p>Show Modal Data</p> */}
                    {this.state.body}
                </Modal>
                <Modal show={this.state.warnModal} className='Modal'  >
                    <ModalHeader>API Key already mapped with below Master Keys.</ModalHeader>
                    <ModalBody>
                        <ul>
                            {this.props.masterkeysByApiKeySuccess.map((p, index) => { return (<li key={index}>{p}</li>) })}
                        </ul>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.handleWarningToggle}>Close</Button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.showFailureModal} className={this.state.resizeZIndex ? 'z-index-zero Large-Modal modal-content' : 'Large-Modal modal-content'} modalClosed={this.closeIt} >
                        <div className="modal-header row pt-0">
                        <h5 className="text-danger"><i className="fa fa-exclamation-triangle">&nbsp;</i>Failure</h5>
                            <button type="button" onClick={this.handleCloseModal} className="close outline-none" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>  
                        </div>
                        <div className="modal-body">
                            <h5>{this.state.failureMessageHeading}</h5><br/>
                            <pre className='validation-error-text'>{this.state.failureMessageBody}</pre>
                            <Button color="info" onClick={this.handleCloseModal}>OK</Button>
                        </div>
                </Modal>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    listData: state.globalConfiguration.masterDataList,
    createMasterDataSuccess: state.globalConfiguration.createMasterDataSuccess,
    createMasterDataFailure: state.globalConfiguration.createMasterDataFailure,
    masterkeysByApiKeySuccess: state.globalConfiguration.masterkeysByApiKeySuccess,
    masterkeysByApiKeyFailure: state.globalConfiguration.masterkeysByApiKeyFailure,
    downloadBulkMasterKeyRequestTemplateSuccess: state.globalConfiguration.downloadBulkMasterKeyRequestTemplateSuccess,
    downloadBulkMasterKeyRequestTemplateFailure: state.globalConfiguration.downloadBulkMasterKeyRequestTemplateFailure,
    submitBulkMasterKeyRequestSuccess: state.globalConfiguration.submitBulkMasterKeyRequestSuccess,
    submitBulkMasterKeyRequestFailure: state.globalConfiguration.submitBulkMasterKeyRequestFailure,
    
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    getMasterDataKeyList: (data) => { dispatch(getMasterDataKeyList(data)) },
    createMasterDataKey: (data) => { dispatch(createMasterDataKey(data)) },
    fetchMasterKeyByApiKey: (data) => { dispatch(fetchMasterKeyByApiKey(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    downloadBulkMasterKeyRequestTemplate: (data) => {dispatch(downloadBulkMasterKeyRequestTemplate(data))},
    submitBulkMasterKeyRequest: (data) => {dispatch(submitBulkMasterKeyRequest(data))}
})
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(MasterDataCreate));
